export default __webpack_public_path__ + "static/breadcrumbs-size-dont-dark-6bea1a707a99678ba62607d51dc7bd69.png";